import { render } from "./SelectedRetailer.vue?vue&type=template&id=47ec198c"
import script from "./SelectedRetailer.vue?vue&type=script&lang=js"
export * from "./SelectedRetailer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__